import './Nav.css';

import { defineMessages, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import PropTypes, { element } from 'prop-types';
import React from 'react';
import alertIcon from './assets/icon-alert.svg';
//import chevronIcon from './assets/icon-chevron-down.svg';
import helpIcon from './assets/icon-help.svg';
import md5 from 'md5';
import { pure } from 'recompose';
import settingsIcon from './assets/icon-settings.svg';
import shiftLogo from './assets/fuse-logo-horizontal-180.svg';

const messages = defineMessages({
  navLogout: {
    id: 'nav.logout',
    description: 'alt tag on logout icon',
    defaultMessage: 'Logout'
  }
});

const Nav = ({ username, logout, intl }) =>
  username ? (
    <div className="nav">
      <ul className="links">
        <li style={{ display: 'none' }}>
          <img alt="" src={helpIcon} />
        </li>
        <li style={{ display: 'none' }}>
          <img alt="" src={settingsIcon} />
        </li>
        <li style={{ display: 'none' }}>
          <img alt="" src={alertIcon} />
        </li>
        <li>
          <a href="" onClick={logout}>
            <img
              className="gravatar"
              alt={intl.formatMessage(messages.navLogout)}
              src={`https://www.gravatar.com/avatar/${md5(
                username.trim().toLowerCase()
              )}?d=mm`}
            />
          </a>
        </li>
        <li className="zero-margin">
          {/* <a href="" onClick={logout}>
            <img alt="" src={chevronIcon} />
          </a> */}
        </li>
      </ul>
      <div className="logo">
        <Link to="/">
          <img alt="FUSE" src={shiftLogo} width="144" height="58" />
        </Link>
      </div>
    </div>
  ) : (
    <div className="nav">
      <div className="logo">
        <Link to="/">
          <img alt="FUSE" src={shiftLogo} width="144" height="58" />
        </Link>
      </div>
    </div>
  );

Nav.propTypes = {
  username: PropTypes.string,
  //logout: PropTypes.func.isRequired,
  intl: PropTypes.object
};

export default pure(injectIntl(Nav));



// WEBPACK FOOTER //
// ./src/components/views/NavNoLogout/index.js